// Built-in product definitions
export interface ProductData {
  id: string;
  name: string;
  defaultPrefix: string;
  width: number;
  height: number;
  maskType: string;
}

export const PRODUCTS_DATA: ProductData[] = [
  { id: 'p1', name: 'Коврик', defaultPrefix: 'KVR', width: 3508, height: 2480, maskType: 'rect' },
  {
    id: 'p2',
    name: 'Круглый коврик',
    defaultPrefix: 'KVR-R',
    width: 3508,
    height: 2480,
    maskType: 'rect',
  },
  { id: 'p3', name: 'Кружка', defaultPrefix: 'MUG', width: 2480, height: 1181, maskType: 'rect' },
  { id: 'p4', name: 'Подушка', defaultPrefix: 'PLW', width: 4606, height: 3307, maskType: 'rect' },
  {
    id: 'p5',
    name: 'Термокружка',
    defaultPrefix: 'TRM',
    width: 3508,
    height: 2480,
    maskType: 'rect',
  },
  { id: 'p6', name: 'Сумка', defaultPrefix: 'BAG', width: 4961, height: 3508, maskType: 'rect' },
];

export const MOCKUP_WIDTH = 900;
export const MOCKUP_HEIGHT = 1200;
